module.exports = __webpack_public_path__ + "static/media/pilot.6c64158b.jpg";